// extracted by mini-css-extract-plugin
export default {"tag":"tag__zS9MG","hidden":"hidden__jJbVx"};